// extracted by mini-css-extract-plugin
module.exports = {"input-wr":"InputCheckbox_input-wr__pf3zf","active":"InputCheckbox_active__32FBt","input":"InputCheckbox_input__1iTBo","invalid":"InputCheckbox_invalid__10sOH"};